import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Spinner, Alert } from "reactstrap";
import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import visileColumns from "./visibleColumns";
import CustomizerContext from "../../../../_helper/Customizer";
import ErrorBoundary from "../../../../ErrorBoundry";
import { getter } from "@progress/kendo-react-common";
import { getSelectedState } from "@progress/kendo-react-data-tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-duotone-svg-icons";
import { Typography } from "@mui/material";
import { post } from "../../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../../_helper/helper";
// import ApplicantsListByEligibility from "../ApplicantsListByEligibility/ApplicantsListByEligibility";

function EligibilityTable({ setCurrentStep }) {
    const id = "GeneralAvailability-By-Announcement";
    const { setApplicantTableShow, EligibilityTableShow, setSingleEligibilityList, setAllApplicantsData, allApplicantsData } = useContext(CustomizerContext);
    const ANNOUNCEMENT_ID_Value = useMemo(() => {
        const { ANNOUNCEMENT_ID } = EligibilityTableShow
        if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim()
        return ""
    }, [EligibilityTableShow])
    // console.log(EligibilityTableShow,'EligibilityTableShow1221')
    const dispatch = useDispatch();
    const history = useNavigate();
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
            results: searchResult.results,
            rowCount: searchResult.rowCount,
        };
    }, [searchResultsV2[id], id]);
    const { userData } = useAuth();
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([{ field: "", dir: "desc" }]);
    const [searchParams, setSearchParams] = useState([{ columnName: "announcement_id", value: ANNOUNCEMENT_ID_Value, operator: "=", dataType: "varchar(50)", logicOperator: "AND" }]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
    const [deleteData, setDeleteData] = useState(null);
    const [gg1ExportParams, setGG1ExportParams] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);

    const { postingResult, loading } = useSelector((state) => state.JobAnnouncementReducer);

    const [modal, setModal] = useState(false);
    const [jobOpenings, setJobOpenings] = useState(0);
    const [showAllApplicants, setShowAllApplicants] = useState(false);
    const [dataState, setDataState] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [applicantsByElgModal, setApplicantsByElgModal] = useState(false)
    const [modalContent, setModalContent] = useState([])
    const [submitLoader, setSubmitLoader] = useState(false)

    console.log(dataState, results, searchResultsV2[id], 'dataStateelg1221')

    const DATA_ITEM_KEY = "GENERAL_AVAILIBILITY_ID";
    const SELECTED_FIELD = "selected";
    const idGetter = getter(DATA_ITEM_KEY);

    useEffect(() => {
        let temp = {}
        if (allApplicantsData && allApplicantsData.length > 0) {
            for (let item of allApplicantsData) {
                if (item.hasOwnProperty("selected") && item?.selected) {
                    temp[item.eligibility_id] = item?.selected
                }
            }
            setSelectedState(temp)
        }
        console.log(allApplicantsData, 'allApplicantsData1221')
    }, [allApplicantsData])

    const newResults = useMemo(
        () => (results?.length > 0 ? JSON.stringify(results) : ""),
        [searchResultsV2]
    );

    const onSelectionChange = React.useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );
    const onHeaderSelectionChange = React.useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
    }, []);
    useEffect(() => {
        if (results) {
            const allValue = Object.keys(selectedState);
            const tempResults = results?.map((dataItem) =>
                Object.assign(
                    {
                        selected: allValue.includes(dataItem[DATA_ITEM_KEY]?.toString()),
                    },
                    dataItem
                )
            );
            setDataState([...tempResults]);
        }
    }, [newResults, searchResultsV2[id]]);
    useEffect(() => {
        let tempDataState = [...dataState];
        setDataState(
            tempDataState.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
            }))
        );
    }, [selectedState]);

    useEffect(() => {
        setSearchParams([{ columnName: "announcement_id", value: ANNOUNCEMENT_ID_Value, operator: "=", dataType: "varchar(50)", logicOperator: "AND" }])
    }, [ANNOUNCEMENT_ID_Value])

    const toggleModal = () => setModal(!modal);

    const getParamData = (data) => {
        setGG1ExportParams(data);
    };

    const handleReset = () => {
        // Reset any relevant state or dispatch actions if needed
    };

    // const actions = useMemo(() => {
    //     return [
    //         {
    //             title: "Show Applicants of Elgibility List",
    //             icon: { iconName: "k-icon k-i-eye" },
    //             className: "font-primary",
    //             style: { cursor: "pointer" },
    //             action: (props) => {
    //                 console.log(props.dataItem,'propsDatautem1221')
    //                 setSingleEligibilityList(props.dataItem)
    //                 setApplicantsByElgModal(true);
    //             },
    //         },
    //     ];
    // }, []);

    const handleModalSubmit = async () => {
        try {
            setSubmitLoader(true)
            const payload = {
                "announcement_id": ANNOUNCEMENT_ID_Value,
                "general_availability_id": modalContent.length == 1 ? modalContent[0].GENERAL_AVAILIBILITY_ID : modalContent.map((item) => item.GENERAL_AVAILIBILITY_ID).join(','),
            }
            const response = await post(`${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateCertList`, payload)
            ShowSucess("Submitted succesfully")
            setTimeout(() => {
                ShowSucess("notification sent to DOA Director for Approvel")
            }, 1000)
            toggleModal();
        }
        catch (error) {
            console.log(error?.message ?? "Somethig went wrong")
            ShowError(error?.message ?? "Something Went Wrong")
        }
        finally {
            setSubmitLoader(false)
        }
    };

    useEffect(() => {
        if (loadingSearch) setexpandedSearchResult(true);
    }, [loadingSearch]);

    useEffect(() => {
        // Update state or perform actions based on postingResult and loading state
    }, [postingResult, loading]);

    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    // useEffect(() => {
    //     setSearchParams([
    //         {
    //             columnName: "ANNOUNCEMENT_ID",
    //             operator: "=",
    //             value: "TESTPOIII",
    //             dataType: "varchar",
    //             logicOperator: "AND",
    //         },
    //     ]);
    // }, []);

    const [sortedColumns, setSortedColumns] = useState(visileColumns);

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const handleCheckboxChange = (event, dataItem) => {
        // Logic for handling checkbox state change
        console.log(dataItem, event.target.checked);
        // setApplicantTableShow(event.target.checked);
    };

    const renderCheckbox = (props) => {
        return (
            <td>
                <input
                    type="checkbox"
                    checked={props.dataItem.selected}
                    onChange={(event) => handleCheckboxChange(event, props.dataItem)}
                />
            </td>
        );
    };

    const handleApplicantsElgModal = () => {
        setApplicantsByElgModal(!applicantsByElgModal)
    }

    const showAllApplicantsHandler = () => {
        const allSelectedElgIds = Object.keys(selectedState).filter((item) => selectedState[item])
        const allSelectedElgData = dataState.filter((item) => allSelectedElgIds.includes(item.GENERAL_AVAILIBILITY_ID))
        console.log(allSelectedElgIds, allSelectedElgData, 'selectedState1221')
        // setAllApplicantsData(allSelectedElgData)
        // setApplicantTableShow(true)
        // setCurrentStep(2)
        setModalContent(allSelectedElgData)
        toggleModal()
    }

    const isShowAllApplicantsButtonVisible = useMemo(() => {
        return Object.values(selectedState).some(value => value);
    }, [selectedState]);

    const isCertListCreated = useMemo(() => {
        const status = EligibilityTableShow?.CERT_LIST_STATUS;
        return Boolean(status && status.trim() !== "");
    }, [EligibilityTableShow]);

    return (
        <ErrorBoundary>
            <Fragment>
                <Container fluid={true}>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card>
                                <CardHeader
                                // style={{
                                //     position: 'sticky',
                                //     top: 0,
                                //     zIndex: 1,
                                //   }}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <div className="d-flex align-items-center justify-content-between mt-1">
                                                <h5 className="m-0">General Availability List</h5>
                                                <div className="d-flex align-items-center gap-2">
                                                    {/* <Button color="primary" onClick={toggleModal}>Get Data</Button> */}
                                                    <Button disabled={!isShowAllApplicantsButtonVisible || !isCertListCreated} color="primary" className="ml-2" onClick={() => {
                                                        showAllApplicantsHandler()
                                                        // setShowAllApplicants(true)
                                                    }
                                                    }>
                                                        Generate Certification List
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <TelerikDataTable
                                        id={id}
                                        pageNumber={page}
                                        pageSize={pageSize}
                                        totalCount={showAllApplicants ? rowCount : Math.min(rowCount, jobOpenings)}
                                        skip={(page - 1) * pageSize}
                                        take={pageSize}
                                        data={dataState || []}
                                        // sortData={sortData}
                                        tableName={"GeneralAvailability-By-Announcement"}
                                        searchParams={searchParams}
                                        additionalWhere={additionalWhere}
                                        onFilterChange={handleFilterChange}
                                        onSortChange={handleSortChange}
                                        onPageChange={handlePageChange}
                                        onPageSizeChange={handlePageSizeChange}
                                        selectedColumns={sortedColumns}
                                        setSortedColumns={setSortedColumns}
                                        loading={loadingSearch}
                                        enableFooterCell={false}
                                        dataLocation="pmis-global"
                                        // actions={actions}
                                        setChooseFilterMethod={setChooseFilterMethod}
                                        showCheckboxes={true}
                                        onHeaderSelectionChange={onHeaderSelectionChange}
                                        onSelectionChange={onSelectionChange}
                                        selectedState={selectedState}
                                        dataItemKeyField={DATA_ITEM_KEY}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Create Certification List</ModalHeader>
                    <ModalBody>
                        <div>
                            <Typography variant="body2">
                                Announcement : <strong>{ANNOUNCEMENT_ID_Value}</strong>
                            </Typography>
                            <Typography variant="body2">
                                General Availability(s) : <strong>{modalContent?.map((item) => item.GENERAL_AVAILIBILITY_ID).join(',')}</strong>
                            </Typography>
                            <Typography variant="body2">
                                Click on "Submit" to create Certification List for Position <b>{[modalContent[0]?.POSITION]}</b>
                            </Typography>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleModalSubmit} disabled={submitLoader}>
                            {submitLoader && <Spinner size="sm" />}
                            Submit
                        </Button>{' '}
                        <Button color="secondary" onClick={toggleModal} disabled={submitLoader}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                {/* <Modal isOpen={applicantsByElgModal} 
                style={{
                    maxWidth: '80%',
                    width: '80%',
                  }}
                >
                    <ModalHeader>
                        Applicants List
                        <Button close onClick={handleApplicantsElgModal} style={{ position: 'absolute', right: '1rem' }}>
                            <FontAwesomeIcon icon={faTimes}/>
                        </Button>
                    </ModalHeader>
                    <ModalBody>
                        <ApplicantsListByEligibility />
                    </ModalBody>
                </Modal> */}
            </Fragment>
        </ErrorBoundary>
    );
}

export default EligibilityTable;
